import React from 'react'
import Signup from '../components/Signup'

export default function Connect() {
  return (
    <div>
        <Signup />
    </div>
  )
}
